import React, { useEffect, useState, useCallback, useRef } from 'react';
import './Home.css';
import HeaderToronto from '../components/HeaderToronto';

const sampleQuestions = [
  {
    id: 1,
    text: 'Unless otherwise posted, what is the basic speed limit outside a city, town or village on a primary highway?',
    options: ['100 km/h', '80 km/h', '60 km/h', '50 km/h'],
    img: null,
    answerIndex: 0,
  },
  
];

const TOTAL_QUESTIONS = 150;

// build initial questions array: use provided sampleQuestions for the first items,
// and placeholders for the rest up to TOTAL_QUESTIONS
const initialQuestions = Array.from({ length: TOTAL_QUESTIONS }, (_, i) => {
  const found = sampleQuestions.find((s) => s.id === i + 1);
  if (found) return found;
  return { id: i + 1, text: `Loading question ${i + 1}...Please upgrade your account or install the app (https://play.google.com/store/apps/details?id=com.codewithnguyen.todoalbertadriving)`, options: [], img: null, answerIndex: null };
});

// const convertToQuestionFormat = (data) => ({
//   id: data._id + 1,
//   text: data.Question,
//   options: data.Answer ? data.Answer.map((a) => a.name) : [],
//   answerIndex: data.isCorrect - 1,
//   tip: data.Tip,
// });

function TorontoPage() {
  const [questions] = useState(initialQuestions);
  const [showNavigator, setShowNavigator] = useState(false);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState({});
  const [bottomCollapsed, setBottomCollapsed] = useState(false);
  const [voice, setVoice] = useState(false);
  const [fontScale, setFontScale] = useState(1);
  const [showPopularity, setShowPopularity] = useState(false);
  const [ambient, setAmbient] = useState(false);
  const quizBodyRef = useRef(null);

  const q = questions[current];
  const qId = q && q.id;
  /*
  const getQuestions = useCallback((id) => {
    fetch('/api/driverassessment/' + id)
      .then((res) => res.json())
      .then((data) => {
        const formatted = convertToQuestionFormat(data[0]);
        setQuestions((prev) => [...prev, formatted]);
        console.log(data);
      })
      .catch((err) => console.error('Error fetching data:', err));
  }, []);
  */
  useEffect(() => {
    //getQuestions(current + 1);
  }, []); // IGNORE
  const goNext = useCallback(() => {
    setSelected(null);
    setCurrent((c) => Math.min(c + 1, questions.length - 1));
  }, [questions.length]);

  const goPrev = useCallback(() => {
    setSelected(null);
    setCurrent((c) => Math.max(c - 1, 0));
  }, []);

  function handleSelect(idx) {
    setSelected(idx);
  }

  // keyboard support for Enter/Space on option items is added in the JSX onKeyDown handlers

  const handleSubmit = useCallback(() => {
    if (selected === null) return; // ignore empty submit
    setAnswers((prev) => ({ ...prev, [qId]: selected }));
    setSubmitted((prev) => ({ ...prev, [qId]: true }));
  }, [selected, qId]);

  function score() {
    let correct = 0;
    let total = questions.length;
    questions.forEach((qq) => {
      const a = answers[qq.id];
      if (a === qq.answerIndex) correct += 1;
    });
    return { correct, wrong: total - correct, total };
  }

  const { correct, wrong, total } = score();
  const answeredCount = Object.keys(answers).length;
  const percent = Math.round((answeredCount / total) * 100);

  useEffect(() => {
    function onKey(e) {
      if (e.key === 'ArrowRight') {
        goNext();
      } else if (e.key === 'ArrowLeft') {
        goPrev();
      } else if (e.key === 'Enter') {
        handleSubmit();
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [goNext, goPrev, handleSubmit]);

  // auto-collapse bottom controls when scrolling down within quiz body (mobile)
  useEffect(() => {
    const el = quizBodyRef.current;
    if (!el) return;
    let last = el.scrollTop;
    const THRESH = 40; // px - require bigger movement to avoid accidental hide
    function onScroll() {
      const st = el.scrollTop;
      if (st > last + THRESH) {
        setBottomCollapsed(true);
      } else if (st < last - THRESH) {
        setBottomCollapsed(false);
      }
      last = st;
    }
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [quizBodyRef]);

  return (
  <>
  <HeaderToronto />
  <div className="app-root">
 

      <main className="quiz-card">
        <div className="quiz-card" style={{ fontSize: `${fontScale}rem` }}>
        <div className="quiz-top">
          <button className="nav-btn" onClick={goPrev} disabled={current === 0} aria-label="Previous question">◀ Prev</button>
          <div className="question-title">
            Question {current + 1} of {questions.length}
            <div className="progress-inline" aria-hidden>
              <div className="progress-bar"><div className="progress" style={{ width: `${percent}%` }} /></div>
              <small>{percent}% answered</small>
            </div>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            {/* <button className="report-btn" onClick={() => console.log('Report question', q.id)} aria-label="Report a mistake">Report</button> */}
            <button className="nav-btn" onClick={goNext} disabled={current === questions.length - 1} aria-label="Next question">Next ▶</button>
          </div>
        </div>

        {/* mobile-only status: show counts near top on narrow viewports so bottom summary isn't hidden */}
        <div className="mobile-status" aria-hidden>
          <div>Correct: {correct}</div>
          <div>Wrong: {wrong}</div>
          <div>Unanswered: {total - answeredCount}</div>
        </div>

        {/* controls moved to bottom bar for better UX */}

        <div className="quiz-body" ref={quizBodyRef}>
          <div className="quiz-main">
            <div className="question-text">{q.text}</div>
            {q.img && (
              <div className="question-image">
                <center><img src={q.img} alt="Question related" /></center>
              </div>
            )}
            <ul className="options-list">
            {q.options.map((opt, idx) => {
              const isSelected = selected === idx;
              const isSubmitted = submitted[q.id];
              const isCorrect = q.answerIndex === idx;
              const showResult = isSubmitted && isSelected;
              // fake popularity distribution when toggled
              const popularity = showPopularity ? Math.max(0, 100 - idx * 15 - (Math.random() * 10)) : null;
              return (
                <li
                  key={idx}
                  role="button"
                  tabIndex={0}
                  className={`option ${isSelected ? 'selected' : ''} ${showResult ? (isCorrect ? 'correct' : 'incorrect') : ''}`}
                  onClick={() => handleSelect(idx)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSelect(idx); } }}
                >
                  <span className="opt-letter">{String.fromCharCode(65 + idx)}</span>
                  <span className="opt-text">{opt}</span>
                  {isSubmitted && isCorrect && <span className="opt-badge">✔</span>}
                  {isSubmitted && isSelected && !isCorrect && <span className="opt-badge">✖</span>}
                  {showPopularity && popularity !== null && (
                    <span className="popularity">{Math.round(popularity)}%</span>
                  )}
                </li>
              );
            })}
              {showNavigator && (
                <div className="navigator-backdrop" onClick={() => setShowNavigator(false)}>
                  <div className="navigator" role="dialog" aria-modal={true} onClick={(e) => e.stopPropagation()}>
                    <div className="navigator-header">Jump to question</div>
                    <div className="navigator-grid">
                      {questions.map((qq, i) => (
                        <button key={qq.id} className={`nav-num ${i === current ? 'active' : ''}`} onClick={() => { setCurrent(i); setShowNavigator(false); }}>
                          {i + 1}
                        </button>
                      ))}
                    </div>
                    <div style={{textAlign:'right', marginTop:8}}><button onClick={() => setShowNavigator(false)}>Close</button></div>
                  </div>
                </div>
              )}
          </ul>

            <div style={{height:8}} />
          </div>

          <div className="actions">
            <button className="submit-btn" onClick={handleSubmit} disabled={selected === null || submitted[q.id]}>Submit</button>
            <button className="clear-btn" onClick={() => { setSelected(null); }} disabled={selected === null}>Clear</button>
          </div>
        </div>

        <div className="quiz-bottom">
          <div className="summary">
            {/* <div>Answered: {Object.keys(answers).length} / {total}</div> */}
            {/* <div className="score">Correct: {correct} • Wrong: {wrong}</div> */}
          </div>
          <div className="jump-list">
            {/* show up to 9 unique nearby numbers centered on current when possible */}
            {(() => {
              const displayCount = Math.min(9, questions.length);
              // try to center current; but clamp to valid range so no duplicates
              let start = current - Math.floor(displayCount / 2);
              start = Math.max(0, Math.min(start, questions.length - displayCount));
              const items = [];
              for (let i = 0; i < displayCount; i++) {
                const idx = start + i;
                const qq = questions[idx];
                const ans = answers[qq.id];
                const answeredClass = ans === undefined ? 'unanswered' : (ans === qq.answerIndex ? 'correct' : 'incorrect');
                items.push(
                  <button key={qq.id} className={`jump-btn ${idx === current ? 'active' : ''} ${answeredClass}`} onClick={() => setCurrent(idx)} aria-label={`Jump to question ${idx+1}`}>
                    {idx + 1}
                  </button>
                );
              }
              return items;
            })()}
            <button className="jump-btn" onClick={() => setShowNavigator(true)}>All</button>
          </div>
        </div>
        </div>
      </main>
      {/* floating bottom controls moved outside quiz-card so they don't cover content */}
  <div className={`bottom-controls ${bottomCollapsed ? 'collapsed' : ''}`} role="toolbar" aria-label="Test controls">
        <div className="bc-left">
          <label className="bc-item"><input type="checkbox" checked={voice} onChange={() => setVoice(v => !v)} /> Voice-over</label>
          <label className="bc-item">Font <button onClick={() => setFontScale(s => Math.max(0.85, s - 0.1))}>A-</button><button onClick={() => setFontScale(s => Math.min(1.4, s + 0.1))}>A+</button></label>
          <label className="bc-item"><input type="checkbox" checked={showPopularity} onChange={() => setShowPopularity(s => !s)} /> Show popularity</label>
        </div>
        <div className="bc-right">
          <label className="bc-item"><input type="checkbox" checked={ambient} onChange={() => setAmbient(a => !a)} /> Ambient music</label>
          <button className="small-cta" onClick={() => alert('Upgrade to Premium for more features')}>Go Premium</button>
        </div>
      </div>
      <button className={`controls-handle ${bottomCollapsed ? 'collapsed' : ''}`} aria-label="Toggle controls" onClick={() => setBottomCollapsed(s => !s)}>
        {bottomCollapsed ? '▲' : '▼'}
      </button>
    </div>
    
    </>
  );
  
}

export default TorontoPage;
